<template>
    <div>
        <b-form-group :state="isValid"
                      :invalid-feedback="invalidFeedback"
                      :description="helpText">
            <template v-slot:label>
                <label class="form-label" :for="fieldName"><slot>{{field.label}}:</slot></label>
            </template>
            <b-form-select :id="fieldId"
                           :value="filteredObject"
                           @input="changeValue"
                           :options="options"
                           value-field="id"
                           :text-field="textField"
                           :state="isValid"
                           :disabled="disabled"
            />
        </b-form-group>
    </div>
</template>

<script>
    import FieldMixin from '@/components/fields/FieldMixin';
    import {isObject} from "lodash";

    export default {
        name: "ModelField",
        mixins: [FieldMixin],
        props: {
            options: {
                type: Array,
                required: true
            },
            textField: {
                type: String,
                default: 'name'
            },
            autoSelect: {
                type: Boolean,
                default: true
            }
        },
        computed: {
            filteredObject() {
                return this.filterObject(this.value);
            }
        },
        created() {
            if (this.autoSelect && this.options.length === 1) {
                this.changeValue(this.filterObject(this.options[0]));
            }
        },
        methods: {
            filterObject(value) {
                if (isObject(value)) {
                    return value.id;
                }
                return value;
            }
        },
    };
</script>

<style scoped>

</style>